import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Container, Header, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Route} from '../components/Router.js'
import * as RouterActions from '../actions/RouterActions';
import {env} from '../constants/Environment';

export default function Dashboard() {
    const dispatch = useDispatch();

    const profile = useSelector(({ firebase: { auth } }) => auth)

    let permissionsSet = useSelector(({firestore}) => (
        typeof profile !== 'undefined' && profile !== null && 
        typeof firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'] !== 'undefined' && 
        typeof firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms !== 'undefined' && 
        firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms !== null
    )?
        firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms
    :{});

    const authorized = (role) => (typeof permissionsSet[role] !== 'undefined' && permissionsSet[role].read === true);

  return (
    <Navigation title="Dashboard" icon="dashboard">
        <div style={{
            marginTop: '50px'
        }}>
            <Container >
                <Header as='h2'>Hallo {profile.displayName}!</Header>

                  <Card.Group itemsPerRow={4}>

                    {authorized('marketing-displays')?
                        <Card>
                            <Card.Content>
                                <Card.Header><Icon name="film" /> Marketing-Displays</Card.Header>
                                <Card.Description>
                                    Events für die Anzeige auf den Marketing Displays auswählen.
                                </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                                <a onClick={() => {
                                    dispatch(RouterActions.push('/displays/'))
                                }}>
                                    <Icon name='arrow right' />
                                    Anzeigen
                                </a>
                            </Card.Content>
                        </Card>
                        :null
                    }

                    <Card>
                        <Card.Content>
                            <Card.Header><Icon name="tasks" /> Eventticker</Card.Header>
                            <Card.Description>
                                Änderungen an Events in einem Ticker anzeigen.
                            </Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                            <a onClick={() => {
                                dispatch(RouterActions.push('/bookmaker/eventticker'))
                            }}>
                                <Icon name='arrow right' />
                                Anzeigen
                            </a>
                        </Card.Content>
                    </Card>

                    {authorized('staticfiles')?
                        <Card>
                            <Card.Content>
                                <Card.Header><Icon name="folder" /> Statische Dateien</Card.Header>
                                <Card.Description>
                                    Statische Dateien verwalten.
                                </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                                <a onClick={() => {
                                    dispatch(RouterActions.push('/staticfiles/files/'))
                                }}>
                                    <Icon name='arrow right' />
                                    Anzeigen
                                </a>
                            </Card.Content>
                        </Card>
                        :null
                    }

                    {authorized('stories')?
                    <Card>
                        <Card.Content>
                            <Card.Header><Icon name="newspaper" /> Beiträge</Card.Header>
                            <Card.Description>
                                Text-Beiträge verfassen.
                            </Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                            <a onClick={() => {
                                dispatch(RouterActions.push('/stories/'))
                            }}>
                                <Icon name='arrow right' />
                                Anzeigen
                            </a>
                        </Card.Content>
                    </Card>
                    :null}

                    {authorized('users')?
                    <Card>
                        <Card.Content>
                            <Card.Header><Icon name="cloud" /> System</Card.Header>
                            <Card.Description>
                                System- und Benutzereinstellungen verwalten.
                            </Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                            <a onClick={() => {
                                dispatch(RouterActions.push('/system/users'))
                            }}>
                                <Icon name='arrow right' />
                                Anzeigen
                            </a>
                        </Card.Content>
                    </Card>
                    :null}
                </Card.Group>
            </Container>
        </div>
    </Navigation>
  )
}